import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'
import StepService from 'src/services/steps.service'

export const useApproveStepAccountConnectionManually = (invalidateQuery: boolean = false) => {
  const queryClient = useQueryClient()
  return useMutation(
    (connnectionId: string) => StepService.approveAccountConnectionManually(connnectionId),
    {
      onSuccess: (data) => {
        if (data) {
          queryClient.invalidateQueries(QUERY_KEYS.STEPS)
          if (invalidateQuery) {
            queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT_STEPS_CONNECTION, data.accountId])
          }
        }
      },
    },
  )
}
